import { SelectionModel } from '@angular/cdk/collections';
import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ConfirmModalComponent } from '../shared/component/confirm-modal/confirm-modal.component';
import { ExternalCommonService } from '../shared/services/external.common.service';
import { ExemptionSearchService } from '../shared/services/exemption.search.service';
import { ExternalFilingRequestService } from '../shared/services/exemptionFilingRequest';
import { forkJoin } from 'rxjs';
import { HistoryItem } from 'projects/admin/src/app/models/exemptionFilling';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit {
  RegistriationControlNumber = '';
  FEIN = '';
  FirstName = '';
  FirstNameSearchType = '1';
  QualificationType = '';
  MiddleName = '';
  ConfirmationNumber = '';
  ExemptionFilingStatus = '';
  LastName = '';
  LastNameSearchType = '1';
  Last4SocialSecurityNumber = '';
  BusinessEntityName = '';
  BirthDate = '';
  isSearch = true;
  BusinessEntityNameSearchType = '1';
  ExpirationDateFrom = '';
  ExpirationDateTo = '';
  BusinessControllNumber = '';
  StateLicenseNumber = '';
  PhysicalAddress = '';
  City = '';
  Status = '';
  FilingDateFrom = '';
  FilingDateTo = '';
  isLoading = false;
  dataSource = new MatTableDataSource<any>();
  dtData: Array<any> = [];
  selection = new SelectionModel<any>(false, []);
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  QualificationTypes: any;
  FilingStatusTypes: any;
  StatusTypes: any;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  isSearching = false;
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  captchaResolved: boolean = false;
  displayedColumns: string[] = [
    'registrationControlNumber',
    'formattedName',
    'filingDate',
    'externalStatusName',
    'filingEntityName',
    'physicalAddress',
  ];
  recaptcha = new FormControl('', Validators.required);
  form!: FormGroup;
  historyData: HistoryItem[] = [];
  exemptionData: any;
  constructor(
    private dialog: MatDialog,
    public datepipe: DatePipe,
    private exemptionSearchService: ExemptionSearchService,
    private formBuilder: FormBuilder,
    private commonService: ExternalCommonService,
    private exemptionFilingRequestService: ExternalFilingRequestService,
    private router: Router
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.router.navigated = false;
        window.scrollTo(0, 0);
      }
    });
    this.commonService.getExternalStatusTypes(true).subscribe((res) => {
      res.splice(1, 0, { id: 0, description: 'All Statuses' });
      res.splice(2, 0, { id: -1, description: 'All Inactive Statuses' });
      this.StatusTypes = res;
    });
  }

  ngOnInit(): void {
    this.dataSource.paginator = this.paginator;
    this.form = this.formBuilder.group({
      recaptcha: this.recaptcha,
    });
  }

  checkCaptcha(captchaResponse: string) {
    this.captchaResolved =
      captchaResponse && captchaResponse.length > 0 ? true : false;
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  pageSizeChanged() {
    console.log(this.pageSize);
    this.loadData();
  }
  pageChanged(event: PageEvent) {
    console.log({ event });
    // this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.loadData();
  }

  private loadData() {
    this.isLoading = true;

    this.exemptionSearchService
      .searchExemption(
        this.currentPage + 1,
        this.pageSize,
        this.getSearchParam()
      )
      .subscribe((x) => {
        this.dataSource = new MatTableDataSource<any>(x.items);
        this.dtData = x;
        this.isLoading = false;
        this.isSearching = true;
        console.log(this.dtData);
        setTimeout(() => {
          this.paginator.pageIndex = this.currentPage;
          this.paginator.length = x.totalItems;
          this.dataSource.sort = this.sort;
        });
        this.isLoading = false;
      });
  }

  onSearch() {
    if (!this.validate()) {
      this.dialog.open(ConfirmModalComponent, {
        data: {
          title: 'Search',
          message:
            'Search criteria must be entered in at least one field.  To search for registrations filed or amended within a certain date range, you must enter both a start and end date.',
        },
      });
    } else {
      this.loadData();
    }
  }

  navigateToExemption(fillingId: any) {
    this.isLoading = true;
    forkJoin({
      exemptionData:
        this.exemptionFilingRequestService.getFilingDetail(fillingId),
      history: this.exemptionFilingRequestService.getHistory(fillingId),
    }).subscribe(({ exemptionData, history }) => {
      console.log(history);
      this.exemptionData = exemptionData;
      history.sort(
        (a: any, b: any) =>
          Date.parse(b.createdDate) - Date.parse(a.createdDate)
      );
      this.historyData = history;
      console.log(exemptionData);
      this.isSearch = false;
      this.isLoading = false;
    });
  }

  getLastName(elemet: any) {}

  validate() {
    var isValid = false;
    if (this.FilingDateFrom && this.FilingDateTo) {
      isValid = true;
    } else {
      if (this.RegistriationControlNumber.trim()) isValid = true;
      if (this.FirstName.trim()) isValid = true;
      if (this.MiddleName.trim()) isValid = true;
      if (this.LastName.trim()) isValid = true;
      if (this.BusinessControllNumber.trim()) isValid = true;
      if (this.BusinessEntityName.trim()) isValid = true;
      if (this.Status.toString().length > 0) isValid = true;
      if (this.FEIN.trim()) isValid = true;
      if (this.StateLicenseNumber.trim()) isValid = true;
      if (this.ExpirationDateFrom && this.ExpirationDateTo) isValid = true;
    }
    return isValid;
  }

  getSearchParam() {
    var searchParams = '';
    if (this.FilingDateFrom && this.FilingDateTo)
      searchParams += `&FilingDateFrom=${this.datepipe.transform(
        this.FilingDateFrom,
        'MM/dd/yyyy'
      )}&FilingDateTo=${this.datepipe.transform(
        this.FilingDateTo,
        'MM/dd/yyyy'
      )}`;
    if (this.RegistriationControlNumber.trim())
      searchParams += `&RegistrationControlNumber=${this.RegistriationControlNumber.trim()}`;
    if (this.FirstName.trim()) {
      searchParams += `&FirstName=${this.FirstName.trim()}`;
      if (this.FirstNameSearchType.trim())
        searchParams += `&FirstNameSearchType=${this.FirstNameSearchType.trim()}`;
    }

    if (this.MiddleName.trim())
      searchParams += `&MiddleName=${this.MiddleName.trim()}`;
    if (this.LastName.trim()) {
      searchParams += `&LastName=${this.LastName.trim()}`;
      if (this.LastNameSearchType.trim())
        searchParams += `&LastNameSearchType=${this.LastNameSearchType.trim()}`;
    }
    if (this.BusinessControllNumber.trim())
      searchParams += `&BusinessControllNumber=${this.BusinessControllNumber.trim()}`;
    if (this.BusinessEntityName.trim()) {
      searchParams += `&BusinessEntityName=${encodeURIComponent(
        this.BusinessEntityName.trim()
      )}`;
      if (this.BusinessEntityNameSearchType.trim())
        searchParams += `&BusinessEntityNameSearchType=${this.BusinessEntityNameSearchType.trim()}`;
    }
    if (this.Status.toString().length > 0)
      searchParams += `&Status=${this.Status}`;
    if (this.FEIN.trim()) searchParams += `&FEIN=${this.FEIN.trim()}`;
    if (this.StateLicenseNumber.trim())
      searchParams += `&StateLicenseNumber=${this.StateLicenseNumber.trim()}`;

    if (this.ExpirationDateFrom && this.ExpirationDateTo)
      searchParams += `&ExpirationDateFrom=${this.datepipe.transform(
        this.ExpirationDateFrom,
        'MM/dd/yyyy'
      )}
    &ExpirationDateTo=${this.datepipe.transform(
      this.ExpirationDateTo,
      'MM/dd/yyyy'
    )}`;
    return searchParams;
  }
}
